import Hypher from 'hypher'
import { english, icelandic } from './patterns'

const getLangObject = function(lang: string) {
  if (lang === 'is') {
    return icelandic
  }
  return english
}

const getTaglessString = function(v: { word: string; inTag: boolean }) {
  var taglessStr = '' // elements of string that are not part of a HTML tag
  for (var i = 0; i < v.word.length; i++) {
    if (v.word[i] === '<') {
      // Tag opening
      v.inTag = true
    } else if (v.word[i] === '>') {
      // Tag closed
      v.inTag = false
    } else if (!v.inTag) {
      // Everything not in between is the string we want
      taglessStr += v.word[i]
    }
  }
  return { word: taglessStr, inTag: v.inTag }
}

export const hyphenate = (string: string, language = 'is') => {
  const config = {
    ...getLangObject(language),
    leftmin: 3,
    rightmin: 3
  }

  const h = new Hypher(config)
  if (string) {
    var inTag = false // Determines whether we are inside a tag or not
    const output = string.split(' ').map(v => {
      var wordObj = { word: v, inTag: inTag }
      wordObj = getTaglessString(wordObj)
      inTag = wordObj.inTag // Remember our place in case we ended in the middle of a tag
      return v.replace(wordObj.word, h.hyphenate(wordObj.word).join('\u00AD'))
    })

    return output.join(' ')
  }

  return string
}
